import React from "react";
import { Link } from "react-router-dom";
import ServiceHero from "../components/ServiceHero";
import Gallery from "../components/Gallery";
import CtaBand from "../components/CtaBand";
import useSeo from "../hooks/useSeo";
import useReveal from "../hooks/useReveal";
import { wallTilePage, seo, business } from "../data/siteData";

export default function WallTileRefinishing() {
  useSeo(seo["/wall-tile-refinishing"].title, seo["/wall-tile-refinishing"].description);
  useReveal();
  return (
    <>
      <ServiceHero
        image={wallTilePage.hero}
        alt="Bathroom wall tile reglazed by Mr. Resurface — before and after"
        title={wallTilePage.h1}
        subtitle={wallTilePage.heroHeadline}
        maxW="max-w-3xl"
      />

      <section className="bg-white pb-16 pt-10">
        <div className="mr-container">
          {wallTilePage.sections.map((s, i) => (
            <div key={s.subhead} className={`mr-body reveal ${i ? "mt-12" : ""}`}>
              <h2 className="mr-h2 text-2xl sm:text-[28px]">{s.subhead}</h2>
              <div className="mt-4">
                {s.paragraphs.map((p) => (
                  <p key={p.slice(0, 30)} className="text-[16.5px]">
                    {p}
                  </p>
                ))}
              </div>
            </div>
          ))}
          <div className="reveal mt-10 flex flex-wrap gap-3">
            <Link
              to="/contact-us"
              className="bg-[#244aa2] px-8 py-3.5 text-[12px] font-bold uppercase tracking-[0.1em] text-white transition-colors duration-200 hover:bg-[#0c2a66]"
            >
              Contact Us
            </Link>
            <a
              href={`sms:1${business.phoneDigits}`}
              className="border-2 border-[#244aa2] px-8 py-3.5 text-[12px] font-bold uppercase tracking-[0.1em] text-[#244aa2] transition-colors duration-200 hover:bg-[#244aa2] hover:text-white"
            >
              Text {business.phone}
            </a>
          </div>
        </div>
      </section>

      <Gallery images={wallTilePage.gallery} title="Wall Tile Reglazing Gallery" />
      <CtaBand headline="Shower wall tiles need TLC too" />
    </>
  );
}
